export default __webpack_public_path__ + "static/media/logo-khaihoanprime.a6d19c24.png";